import { __ } from "@wordpress/i18n";
const { Panel, PanelBody, SelectControl } = wp.components;
const { InspectorControls } = wp.blockEditor;
const { withSelect } = wp.data;
const { compose } = wp.compose;

const Settings = (props) => {
  const {
    props: { attributes, setAttributes },
    docs,
  } = props;
  const { data } = attributes;
  let selectBox;
  if (docs) {
    selectBox = docs.map((item, index) => {
      return { label: item?.title?.rendered, value: item?.id };
    });
    selectBox = [{ label: "Select", value: null }, ...selectBox];
  }

  return (
    <InspectorControls style={{ marginBottom: "40px" }}>
      <Panel>
        <PanelBody>
          <SelectControl label="Size" value={data?.tringle_text} options={selectBox} onChange={(id) => setAttributes({ data: { tringle_text: id } })} />
        </PanelBody>
      </Panel>
    </InspectorControls>
  );
};

export default compose([
  withSelect((select, props) => {
    const docs = select("core").getEntityRecords("postType", "pdfposter", { per_page: 100 });
    return {
      docs,
    };
  }),
])(Settings);
